import { forwardRef } from "react";
import type { HTMLAttributes, ReactNode } from "react";
import "./EmptyState.css";

export type EmptyStateTone = "default" | "neutral" | "error";

export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  tone?: EmptyStateTone;
}

const cx = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(" ");

export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(function EmptyState(
  { icon, title, description, actions, tone = "default", className, ...rest },
  ref,
) {
  return (
    <div ref={ref} className={cx("go4-empty", `go4-empty--${tone}`, className)} {...rest}>
      {icon ? <div className="go4-empty__icon">{icon}</div> : null}
      <h3 className="go4-empty__title">{title}</h3>
      {description ? <p className="go4-empty__description">{description}</p> : null}
      {actions ? <div className="go4-empty__actions">{actions}</div> : null}
    </div>
  );
});
